
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { ObjectManager } from '../../../concepts/objects';
import { Physical, RelativeTo } from '../../canvas/entities/Physical';
import { SpatialIndex } from '../../canvas/utilities/SpatialIndex';
import { ActiveObject, resolve } from '../../Container';
import { AutoLayout } from './AutoLayout';
import { autoLayout } from './AutoLayoutCommands';

export class AutoLayoutMechanics extends ActiveObject {

    @resolve(CommandDispatcher) private dispatch!: CommandDispatcher;
    @resolve(ObjectManager) private objects!: ObjectManager;
    @resolve(SpatialIndex) private spatial!: SpatialIndex;

    public start(): void {
        this.burden(
            this.objects.createTrigger('AutoLayout.LayoutModeChanged')
                .for(AutoLayout)
                .onChangesTo('layoutMode')
                .doForEach(x => {
                    this.dispatch(autoLayout, [x.id, true]);
                }),
            this.objects.createTrigger('AutoLayout.ContainerScaled')
                .for(AutoLayout)
                .onManipulated('scale')
                .doForEach(x => {
                    this.dispatch(autoLayout, [x.id, true]);
                }),

            //
            // This was causing crashes when cloning (using ALT)
            //

            // this.objects.createTrigger('AutoLayout.InvalidateShape')
            //     .for(Physical)
            //     .onManipulated('translate', 'scale')
            //     .onPlaced()
            //     .do(this.maybeInvalidateAutoLayout)
        );
    }

    private maybeInvalidateAutoLayout = (physicals: Physical[]) => {
        const containers = new Set<AutoLayout>();
        for (const p of physicals) {
            const hits = this.spatial.lookup(p.bounds(RelativeTo.Model), AutoLayout);
            for (const h of hits) {
                containers.add(h);
            }
        }
        for (const c of containers) {
            this.dispatch(autoLayout, [c.id]);
        }
    };
}
